import {Navigate, Route, Routes} from 'react-router-dom'
import {Registration} from '../registration/Registration'
import {Login} from './components/Login'

const AuthPage = () => (
  <Routes>
    <Route path='registration/:token' element={<Registration />} />
    <Route path='login' element={<Login />} />
    {/* Bare /auth is the URL an admin actually types, so send it to the sign-in form.
        It previously fell through to the catch-all, whose relative redirect resolved to
        /auth/digitalcard, matched the catch-all again and redirected to itself - a blank page. */}
    <Route index element={<Navigate to='/auth/login' replace />} />
    <Route path='' element={<Navigate to='/auth/login' replace />} />
    {/* Absolute so it can never target a path inside /auth and loop. */}
    <Route path='*' element={<Navigate to='/digitalcard' replace />} />
  </Routes>
)

export {AuthPage}
